/**
 * Created by ivan on 11.04.18.
 */

const UnitShopToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.UNIT_SHOP);

    cleverapps.vipAdsAdapter.on("vip_status_changed", () => {
        if (Map2d.currentMap && cleverapps.unitsLibrary) {
            this.resetState();
        }
    }, this);

    this.enable();
};

UnitShopToolbarItem.prototype = Object.create(ToolbarItem.prototype);
UnitShopToolbarItem.prototype.constructor = UnitShopToolbarItem;

UnitShopToolbarItem.prototype.resetState = function () {
    if (!cleverapps.unitsShop) {
        return;
    }

    this.tabWithFree = undefined;
    cleverapps.unitsShop.getAvailableShops().forEach((shop) => {
        if (cleverapps.unitsShop.tabs[shop.tab].getFreeProduct()) {
            this.tabWithFree = shop.tab;
        }
    });

    if (this.tabWithFree !== undefined) {
        this.mark();
    } else {
        this.unmark();
    }
};

UnitShopToolbarItem.prototype.isVisible = function () {
    return cleverapps.unitsShop && cleverapps.unitsShop.getAvailableShops().length > 0;
};

UnitShopToolbarItem.prototype.onClick = function () {
    cleverapps.tutorial.trigger("click_on_units_shop");

    const shops = cleverapps.unitsShop.getAvailableShops();

    let targetTab;
    let stack;

    if (Map2dLocation.currentLocation.tutorial.isActive() && Map2dLocation.currentLocation.tutorial.getId() === "salepass") {
        for (let i = 0; i < shops.length; i++) {
            if (shops[i].tab === ShopWindow.TABS.UNITS_FRUIT) {
                targetTab = ShopWindow.TABS.UNITS_FRUIT;
                break;
            }
        }
        stack = true;
    }

    if (!targetTab) {
        targetTab = this.tabWithFree !== undefined ? this.tabWithFree : shops[0].tab;
    }

    cleverapps.focusManager.display({
        stack,
        focus: `displayUnitsShop${targetTab}`,
        control: ["MenuBarGoldItem", "MenuBarCoinsItem"],
        actions: [
            (f) => {
                new UnitsShopWindow({ tab: targetTab });
                cleverapps.focusManager.onceNoWindowsListener = f;
            },
            (f) => {
                const cart = cleverapps.persist.acceptNode("UnitsShopCart");
                if (cart) {
                    cart.processItems(f);
                } else {
                    f();
                }
            }
        ]
    });
};